var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00050354 5.99991C0.00050354 6.22368 0.0861053 6.43829 0.238479 6.59653C0.390852 6.75476 0.597515 6.84366 0.813004 6.84366H10.2266L6.73775 10.465C6.66221 10.5435 6.60228 10.6366 6.5614 10.7391C6.52052 10.8416 6.49948 10.9515 6.49948 11.0624C6.49948 11.1733 6.52052 11.2832 6.5614 11.3857C6.60228 11.4882 6.66221 11.5813 6.73775 11.6598C6.81329 11.7382 6.90298 11.8005 7.00168 11.8429C7.10038 11.8854 7.20617 11.9072 7.313 11.9072C7.41984 11.9072 7.52562 11.8854 7.62433 11.8429C7.72303 11.8005 7.81271 11.7382 7.88825 11.6598L12.7633 6.59728C12.8389 6.5189 12.8989 6.42579 12.9399 6.32329C12.9809 6.22078 13.002 6.11089 13.002 5.99991C13.002 5.88892 12.9809 5.77903 12.9399 5.67652C12.8989 5.57402 12.8389 5.48091 12.7633 5.40253L7.88825 0.340031C7.73569 0.181598 7.52876 0.0925903 7.313 0.0925903C7.09724 0.0925903 6.89032 0.181598 6.73775 0.340031C6.58519 0.498465 6.49948 0.713347 6.49948 0.937406C6.49948 1.16147 6.58519 1.37635 6.73775 1.53478L10.2266 5.15616H0.813004C0.597515 5.15616 0.390852 5.24505 0.238479 5.40329C0.0861053 5.56152 0.00050354 5.77613 0.00050354 5.99991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0aea6ce9.svg";
export { ForwardRef as ReactComponent };